import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Parser from "html-react-parser";
import Testimonial from "./testimonial";

function FooterHero(props) {
  // Declare a new state variable, which we'll call "count"

  const { data } = props;
  return (
    <>
      <div style={{ paddingTop: "50px" }}>
        <h1 className="widget-title">{data.title}</h1>
        <iframe width="100%" style={{aspectRatio: "16 / 9", width: "100% !important"}} src={data.video_link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </>
  );
}

export default FooterHero;
